import 'alpinejs';
import 'jquery';
import modules from './modules/modules.js';
import Headroom from 'headroom.js';

$(document).ready(() => {
  modules();

  // Headroom
	const myElement = document.querySelector("header.banner");
	const headroom  = new Headroom(myElement);
	headroom.init();

});
